import Service from "../Service";
const resource = "TasWeeklyProjection/";

export default {
    save(cmp, requestID) {
        console.log("cmp", cmp);

        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    realVsExpected(CmaID, FltID, year, requestID) {
        return Service.get(resource + "real-vs-expected", {
            params: {
                CmaID: CmaID,
                FltID: FltID,
                Year: year,
                requestID: requestID
            },
        });
    },


    FilterListSupervice(documentNumber, requestID) {
        return Service.post(resource + "listSuperviceFilter", {}, {
            params: { DocumentNumber: documentNumber, RequestID: requestID },
        });
    },

    saveList(cmp, requestID) {

        return Service.post(resource + "saveList", cmp, {
            params: { requestID: requestID },
        });
    },

    excel(cmp, requestID) {

        console.log(cmp)
        console.log(requestID)
        return Service.post(resource + "reportExcel", cmp, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: { requestID: requestID }
        });
    },
    TasWeeklyProjectionLoteCampaign(FltID, CmaID, requestID) {
        return Service.get(resource + "TasWeeklyProjectionLoteCampaign", {
            params: {
                FltID: FltID,
                CmaID: CmaID,
                requestID: requestID
            },
        });
    },
    Notifications(usrID, requestID) {
        return Service.post(resource + "Notifications", {}, {
            params: { UsrID: usrID, requestID: requestID },
        });
    },
    requiresAnalysis(filter, requestID) {
        return Service.post(resource + "RequiresAnalysis", filter, {
            params: { requestID: requestID },
        });
    },
    updateRequiresAnalysis(data, requestID) {
        return Service.post(resource + "UpdateRequiresAnalysis", data, {
            params: { requestID: requestID },
        });
    },

};